import { map, isNull, isEmpty } from 'lodash/fp';
import { Component } from 'react';
import { TextKey, ActionType, SearchType } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { createUUID } from '@mews/std';
import { Loader, WithBreakpointRange, isMobileOrTablet } from '@mews-commander/ui';
import { IconName, Stack, withBreakpointRange } from '@optimus-web/core';
import ModalHeader from '../../../legacy/React/Components/Common/ModalHeader';
import SearchField from '../../search/containers/SearchField';
import MemberItem from './MemberItem';
import { MembersBlockWrapper, PanelBodyElement, PanelCard } from './style';

interface Props extends WithBreakpointRange {
    isLoading?: boolean;
    members?: $TSFixMe[]; // TODO: pt.instanceOf(Member)
    memberProfileIds?: string[];
    threadId: string;
    onMemberSelect: $TSFixMeFunction;
    onClosePanel: $TSFixMeFunction;
}

class MembersPanelComponent extends Component<Props> {
    private readonly scope = createUUID();

    handleMemberSelected = (member: $TSFixMe) => {
        if (!isNull(member)) {
            this.props.onMemberSelect(this.props.threadId, member.options);
        }
    };

    renderLoader = () => (
        <Stack alignment="center" fill>
            <Loader />
        </Stack>
    );

    renderMembers = map((member) => (
        <MemberItem
            key={(member as $TSFixMe).profileId}
            threadId={this.props.threadId}
            profileId={(member as $TSFixMe).profileId}
        />
    ));

    renderBody = () => {
        const { members, memberProfileIds } = this.props;
        return (
            <PanelBodyElement>
                <Stack vertical spacing="200">
                    {/* @ts-expect-error $TSFixMeError: Type '{ label: Element; scope: string; except: string[] | undefined; searchTypes: SearchType[]; onResultClick: (member: ... */}
                    <SearchField
                        label={<LocalizedText textKey={TextKey.AddMembers} />}
                        scope={this.scope}
                        except={memberProfileIds}
                        searchTypes={[SearchType.EnterpriseProfile]}
                        onResultClick={this.handleMemberSelected}
                    />
                    {this.renderMembers(members)}
                </Stack>
            </PanelBodyElement>
        );
    };

    render() {
        // @ts-expect-error $TSFixMeError: Property 'membersVisible' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { onClosePanel, isLoading, members, membersVisible, breakpointRange } = this.props;
        const isSmall = isMobileOrTablet(breakpointRange);

        const closeAction = isSmall
            ? {
                  type: ActionType.Link,
                  text: <LocalizedText textKey={TextKey.Back} />,
                  icon: IconName.ArrowLeft,
                  onClick: onClosePanel,
              }
            : null;

        return (
            <MembersBlockWrapper isSmall={isSmall} isActive={membersVisible}>
                <PanelCard padding="0">
                    {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                    <ModalHeader title={<LocalizedText textKey={TextKey.Members} />} primaryAction={closeAction} />
                    {isLoading && isEmpty(members) ? this.renderLoader() : this.renderBody()}
                </PanelCard>
            </MembersBlockWrapper>
        );
    }
}

export default withBreakpointRange(MembersPanelComponent);
